import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';

import NotFoundPage from '@/features/App/404';
import ServerErrorPage from '@/features/App/500';
import LoginPage from '@/features/App/login';
import PluginIndex from '@/features/FrontPlugin/PluginIndex';
import PluginLayout from '@/features/FrontPlugin/PluginLayout';
import PluginHomePage from '@/features/FrontPlugin/workspace/PluginHomePage';
import RequestAccessPage from '@/features/Setting/Integrations/integrationRedirection/request-access';
import WorkspaceLayout from '@/features/Workspace/WorkspaceLayout';
import WorkspaceRedirection from '@/features/Workspace/WorkspaceRedirection';

const frontPluginRouter: ReturnType<typeof createBrowserRouter> =
  createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<PluginLayout />}>
        <Route index element={<PluginIndex />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="request-access/:id" element={<RequestAccessPage />} />
        <Route path="500" element={<ServerErrorPage />} />
        <Route path="workspace" element={<WorkspaceLayout />}>
          <Route index element={<WorkspaceRedirection />} />
          <Route path=":workspace_id" element={<PluginHomePage />}></Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>,
    ),
  );

export default frontPluginRouter;
